exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".new-transfer{display:flex;flex-flow:row wrap}.new-transfer main{flex:0 0 auto;width:calc(99.99% * 3/4 - 5px)}.new-transfer main:nth-child(1n){margin-right:20px}.new-transfer main:last-child{margin-right:0}.new-transfer main:nth-child(4n){float:right;margin-right:0}.new-transfer aside{flex:0 0 auto;width:calc(99.99% * 1/4 - 15px);margin-top:30px}.new-transfer aside:nth-child(1n){margin-right:20px}.new-transfer aside:last-child{margin-right:0}.new-transfer aside:nth-child(4n){float:right;margin-right:0}.new-transfer .customer-label,.new-transfer .dealer-label,.new-transfer .product-info-label{color:#aaa;font-size:1.8rem;font-weight:700;padding-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/product/new-transfer/components/new-transfer.scss
// module id = 5135
// module chunks = 0